'use strict';

var utils = require('org/util/utils');
var toggleSearchBarBool;

/**
 * Toggle Search Bar
 */
function toggleSearchBar() {
    if (utils.mediaBreakpointDown('md')) {
        if (!toggleSearchBarBool) {
            $('#expandableSearch input.search-field').attr('aria-expanded', 'true');
            $('.search:not(#expandableSearch) input.search-field').attr('aria-expanded', 'false');
            toggleSearchBarBool = true;
        }
    } else if (!utils.mediaBreakpointDown('md')) {
        if (toggleSearchBarBool || toggleSearchBarBool === undefined) {
            $('#expandableSearch input.search-field').attr('aria-expanded', 'false');
            $('.search:not(#expandableSearch) input.search-field').attr('aria-expanded', 'true');
            toggleSearchBarBool = false;
        }
    }
}

module.exports = {
    initTopCalloutKeyboard: function () {
        $(document).on('keydown', '.top-callout-toggler[role="button"]', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    },


    /**
     * JS observer to detect when a target element is scrolled outside the viewport, toggling a class on site-header to handle "stuck" state via SCSS
     */
    initStickyHeader: function () {
        if (!document.body.contains(document.querySelector('.sticky-scroll-trigger')) || !('IntersectionObserver' in window)) {
            return;
        }
        const target = document.querySelector('.sticky-scroll-trigger');
        const options = {
            rootMargin: '0px',
            threshold: 0
        };
        const headerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    $('.site-header').toggleClass('is-stuck', entry.intersectionRatio === 0 && !$('.menu-toggleable-left').hasClass('in'));
                });
            }, options
        );

        headerObserver.observe(target);
    },

    resize: function () {
        utils.smartResize(function () {
            toggleSearchBar();
        });
    },

    toggleSearchBar
};
